<template>
    <main class="main">
        <div class="container-fluid px-0" data-layout="container">

            <aside-main/>

            <header-main/>

            <div class="content">

                <div class="card-header mb-5 d-flex flex-between-center">
                    <div class="d-flex align-items-center">
                        <h2>Транзакции</h2>
                    </div>
                </div>

                <div class="card-body p-0 spinner-center" v-if="preloader">
                    <div class="p-4 code-to-copy">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </div>

                <div class="row g-5" v-if="!preloader">
                    <div class="col-xl-12 mb-5">
                        <form class="row g-3" v-on:submit.prevent="update">

                            <div class="col-sm-6 col-md-4">
                                <div class="form-floating">
                                    <input
                                        v-model="data.spending_month"
                                        @input="errors.spending_month = null"
                                        :class="{'is-invalid': errors.spending_month}"
                                        placeholder="Месяц"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Месяц</label>
                                    <div class="invalid-feedback">{{errors.spending_month}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-4">
                                <div class="form-floating">
                                    <input
                                        v-model="data.spending_month_value"
                                        @input="errors.spending_month_value = null"
                                        :class="{'is-invalid': errors.spending_month_value}"
                                        placeholder="Траты"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Траты</label>
                                    <div class="invalid-feedback">{{errors.spending_month_value}}</div>
                                </div>
                            </div>

                            <div class="col-sm-6 col-md-4">
                                <div class="form-floating">
                                    <input
                                        v-model="data.profit_month_value"
                                        @input="errors.profit_month_value = null"
                                        :class="{'is-invalid': errors.profit_month_value}"
                                        placeholder="Доходы"
                                        class="form-control" 
                                        type="text"/>
                                    <label>Доходы</label>
                                    <div class="invalid-feedback">{{errors.profit_month_value}}</div>
                                </div>
                            </div>

                            <div class="card-header p-2 mt-4 d-flex flex-between-center" style="margin-bottom: -10px;">
                                <div class="d-flex align-items-center">
                                    <h2 class="fs-1">Операции</h2>
                                </div>

                                <div class="d-flex">
                                    <a 
                                        @click="newDate"
                                        class="btn btn-primary mb-1 float_right">Новая дата</a>
                                </div>
                            </div>

                            <hr/>


                            <template v-for="(item, index_date) in data.history">

                                <div class="card-header p-2 mt-1 d-flex flex-between-center" style="margin-bottom: -10px;">
                                    <div class="d-flex align-items-center">
                                        <h2 class="fs-1">Транзакции</h2>
                                    </div>

                                    <div class="d-flex">
                                        <a 
                                            @click="newTransaction(index_date)"
                                            class="btn btn-primary mb-1 float_right">Новая транзакция</a>
                                        <a 
                                            @click="deleteDate(index_date)"
                                            class="btn btn-danger mb-1 float_right"
                                            style="margin-left: 5px;">Удалить</a>
                                    </div>
                                </div>


                                <div class="col-sm-12 col-md-6">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.history[index_date].date"
                                            placeholder="Дата"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Дата</label>
                                    </div>
                                </div>

                                <div class="col-sm-12 col-md-6">
                                    <div class="form-floating">
                                        <input
                                            v-model="data.history[index_date].amount"
                                            placeholder="Дата"
                                            class="form-control" 
                                            type="text"/>
                                        <label>Сумма</label>
                                    </div>
                                </div>

                                <div class="row g-2" style="margin-left: 0px;" v-for="(item, index) in item.transactions">

                                    <div class="col-sm-2 col-md-2">
                                        <div class="form-floating">
                                            <input
                                                v-model="data.history[index_date].transactions[index].name"
                                                placeholder="Название услуги"
                                                class="form-control" 
                                                type="text"/>
                                            <label>Название услуги</label>
                                        </div>
                                    </div>

                                    <div class="col-sm-2 col-md-2">
                                        <div class="form-floating">
                                            <input
                                                v-model="data.history[index_date].transactions[index].description"
                                                placeholder="Описание"
                                                class="form-control" 
                                                type="text"/>
                                            <label>Описание</label>
                                        </div>
                                    </div>

                                    <div class="col-sm-1 col-md-1">
                                        <div class="form-floating">
                                            <input
                                                v-model="data.history[index_date].transactions[index].amount"
                                                placeholder="Сумма"
                                                class="form-control" 
                                                type="text"/>
                                            <label>Сумма</label>
                                        </div>
                                    </div>

                                    <div class="col-sm-1 col-md-1">
                                        <div class="form-floating">
                                            <input
                                                v-model="data.history[index_date].transactions[index].cashback"
                                                placeholder="Кешбэк"
                                                class="form-control" 
                                                type="text"/>
                                            <label>Кешбэк</label>
                                        </div>
                                    </div>

                                    <div class="col-sm-2 col-md-2">
                                        <div class="form-floating">
                                            <input
                                                v-model="data.history[index_date].transactions[index].card"
                                                placeholder="Карта"
                                                class="form-control" 
                                                type="text"/>
                                            <label>Карта</label>
                                        </div>
                                    </div>


                                    <div class="col-sm-6 col-md-4">
                                        <div class="form-floating v-select-medium select-both-button-row">
                                            <div 
                                                @click="$refs.uploadImage.click()"
                                                content="Загрузить новое изображение" 
                                                v-tippy="{arrow : true, arrowType: 'round'}"
                                                class="select-button-left">
                                                <span class="vertical-center-icon">
                                                    <i class="fa-solid fa-plus"></i>
                                                </span>
                                            </div>
                                            <div>
                                                <vue-select
                                                    v-model="data.history[index_date].transactions[index].image"
                                                    :options="utils.images.transactions" 
                                                    placeholder="Изображение">
                                                    <template v-slot:option="option">
                                                        <img style="width: 30px;margin-right: 20px;height: 100%;" :src="`${$config.ApplicationPublicURL}/img/tinkoff/history/transactions/${option.label}`"/>
                                                        <a 
                                                            @click="deleteImage(option.label)"
                                                            content="Удалить" 
                                                            v-tippy="{arrow : true, arrowType: 'round'}"
                                                            class="btn btn-sm btn-soft-danger ms-2" 
                                                            style="position: absolute; right: 1rem;">
                                                            <i class="fa-regular fa-trash"></i>
                                                        </a>
                                                    </template>
                                                    <template v-slot:no-options="{ search, searching }">
                                                      <template v-if="searching">
                                                         Ничего не найдено по запросу <em>{{ search }}</em>.
                                                      </template>
                                                    </template>
                                                </vue-select>
                                                <label class="custom-select-label">Изображение</label>
                                            </div>

                                            <button
                                                @click="changeTransactionStatus(index_date, index)"
                                                :content="data.history[index_date].transactions[index].status == 1 ? 'Отключить' : 'Включить'" 
                                                v-tippy="{arrow : true, arrowType: 'round'}"
                                                type="button"
                                                class="btn btn-soft-secondary select-button-right">
                                                <span class="vertical-center-icon">
                                                    <i class="icon-paysystem fa-regular" :class="{'fa-circle-pause': data.history[index_date].transactions[index].status == 1, 'fa-play': data.history[index_date].transactions[index].status == 0}"></i>
                                                </span>
                                            </button>

                                            <button
                                                @click="deleteTransaction(index_date, index)"
                                                content="Удалить" 
                                                v-tippy="{arrow : true, arrowType: 'round'}"
                                                type="button"
                                                class="btn btn-soft-danger select-button-right-2">
                                                <span class="vertical-center-icon">
                                                    <i class="icon-paysystem fa-regular fa-trash"></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                </div>

                                <hr class="mt-5" v-if="index_date < data.history.length - 1"/>
                            </template>

                            <input ref="uploadImage" type="file" @input="uploadImage" accept=".png, .jpg, .jpeg, .gif, .svg" style="display: none;">

                            <div class="col-sm-3 col-md-3 mt-5">
                                <button class="btn btn-primary px-5 w-100 text-nowrap" type="submit" :class="{'disabled': btn_preloader}">
                                    <span class="spinner-border spinner-border-sm spinner-border-custom" role="status" v-if="btn_preloader"></span>
                                    <span>Сохранить</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                
                <footer-main/>

            </div>

        </div>
    </main>
</template>

<script>
export default {
    props: ['id'],
    data () {
        return {
            preloader: true,
            btn_preloader: false,
            data: {
                spending_month: null,
                spending_month_value: null,
                profit_month_value: null,

                history: [
                    {
                        date: 'Сегодня',
                        amount: 1000,
                        transactions: [
                            {
                                image: null,
                                name: null,
                                description: null,
                                amount: null,
                                cashback: null,
                                card: null,
                                status: 1
                            }
                        ]
                    },
                    {
                        date: 'Вчера',
                        amount: 1000,
                        transactions: [
                            {
                                image: null,
                                name: null,
                                type: null,
                                amount: null,
                                cashback: null,
                                card: null,
                                status: 1
                            }
                        ]
                    }
                ]
            },
            errors: {
                spending_month: false,
                spending_month_value: false,
                profit_month_value: false,
            },
            utils: {
                images: {
                    transactions: []
                }
            }
        }
    },
    methods: {
        getItem () {
            this.$axios.post('/tinkoff_new/item/history')
            .then(async (response) => {
                this.preloader = false
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':

                        this.data = response.data

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        update () {
            this.btn_preloader = true
            this.$axios.post('/tinkoff_new/history/update', JSON.stringify(this.data))
            .then((response) => {
                this.btn_preloader = false
                response = response.data
                switch (response.status) {
                    case "error":
                        this.$toast.error(response.message)
                        break
                    case "success":
                        this.$toast.success(response.message)

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                this.btn_preloader = false
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    if('field' in response) {
                        this.errorByPatch(this.errors, response.field, response.message)
                    } else {
                        this.$toast.error(response.message)
                    }
                }
            })
        },
        getImages () {
            this.$axios.post('/tinkoff_new/history/images/transactions/items')
            .then((response) => {
                response = response.data
                switch (response.status) {
                    case 'error':
                        this.$toast.error(response.message)
                        break
                    case 'success':
                        this.utils.images.transactions = response.data

                        this.setUser(response.user)
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
                let response = error.response.data
                this.setUser(response.user)

                if('status' in response && response.status == 'error') {
                    this.$toast.error(response.message)
                }
            })     
        },
        uploadImage (e) {
            var formData = new FormData()
            formData.append("image", e.target.files[0])

            this.$confirm('Вы уверены что хотите загрузить это изображение?').then(() => {
                this.$axios.post('/tinkoff_new/history/images/transactions/upload', formData)
                .then((response) => {
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':
                            this.getImages()
                            this.$toast.success(response.message)

                            this.setUser(response.user)
                            break
                        default:
                            this.$toast.error('Unknown error')
                    }
                }).catch((error) => {
                    let response = error.response.data
                    this.setUser(response.user)

                    if('status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })  
            })
        },
        deleteImage (image) {
            this.$confirm('Вы уверены что хотите удалить это изображение?').then(() => {
                this.$axios.post('/tinkoff_new/history/images/transactions/delete', JSON.stringify({
                    image: image
                }))
                .then((response) => {
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':
                            this.getImages()
                            this.$toast.success(response.message)

                            this.setUser(response.user)
                            break
                        default:
                            this.$toast.error('Unknown error')
                    }
                }).catch((error) => {
                    let response = error.response.data
                    this.setUser(response.user)

                    if('status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })  
            })
        },
        errorByPatch (layer, path, value) {
            path = path.split('.')

            path.forEach((value, index) => {
                if (!isNaN(value)) {
                    path[index] = parseInt(value)
                }
            })

            for (var i = 0; i < path.length; i++) {
                if (value != null && i + 1 === path.length) {
                    layer[path[i]] = value
                }
                layer = layer[path[i]]
            }
            return layer
        },
        newDate () {
            this.data.history.push({
                date: 'Сегодня',
                amount: 1000,
                transactions: [
                    {
                        image: null,
                        name: null,
                        description: null,
                        amount: null,
                        cashback: null,
                        card: null,
                        status: 1
                    }
                ]
            })
        },
        deleteDate (index_date) {
            if(this.data.history.length > 1) {
                this.data.history.splice(index_date, 1)
            }
        },


        newTransaction(index_date) {
            this.data.history[index_date].transactions.push({
                image: null,
                name: null,
                description: null,
                amount: null,
                cashback: null,
                card: null,
                status: 1
            })
        },

        deleteTransaction(index_date, index) {
            if(this.data.history[index_date].transactions.length > 1) {
                this.data.history[index_date].transactions.splice(index, 1)
            }
        },

        changeTransactionStatus (index_date, index) {
            this.data.history[index_date].transactions[index].status = this.data.history[index_date].transactions[index].status ? 0 : 1
        }
    },
    beforeMount() {
        this.getItem()
        this.getImages()
    }
}
</script>

<style lang="css" scoped>
    ::v-deep .vs__clear {
        display: none;
    }
    /*::v-deep .vs__selected {
        font-size: 10px !important;
    }*/
    ::v-deep .vs__dropdown-toggle {
        max-height: 48px;
    }
</style>
